import {useCountryLang} from "./useCountryLang";
import {useQuery} from '@tanstack/react-query';
import {request} from "../shared/httpInterceptor";

export const fetchCustomCategories = async (countryLang: string | null, host?: string) => {
  const res = await request({
    url: `/${countryLang}/category/tree/limitedTime`,
    method: 'get',
    host: host
  });
  return res.data;
}

const useCustomCategories = () => {
  const countryLang = useCountryLang()
  return useQuery(["custom-categories", countryLang], () => fetchCustomCategories(countryLang),
    {enabled: countryLang!=null});
}

export default useCustomCategories;